import React from 'react';
export function CTASection() {
  return <section id="cta" className="py-24 px-4 relative" data-id="element-1">
      <div className="max-w-4xl mx-auto bg-zinc-900 border border-amber-500/20 shadow-2xl relative overflow-hidden" data-id="element-2">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent" data-id="element-3"></div>

        <div className="p-8 md:p-16 text-center" data-id="element-4">
          <h2 className="text-3xl md:text-4xl font-serif text-zinc-100 mb-8" data-id="element-5">
            Inicia tu proceso hoy
          </h2>

          <div className="bg-zinc-950/50 p-6 inline-block mb-10 border border-zinc-800 text-left" data-id="element-6">
            <h3 className="text-amber-500 font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-7">
              Recibes acceso inmediato a:
            </h3>
            <ul className="space-y-3 text-zinc-300" data-id="element-8">
              <li className="flex items-center gap-3" data-id="element-9">
                <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-10"></div>
                Protocolo Completo (Digital)
              </li>
              <li className="flex items-center gap-3" data-id="element-11">
                <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-12"></div>
                Hojas de Trabajo Prácticas
              </li>
              <li className="flex items-center gap-3" data-id="element-13">
                <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-14"></div>
                Guion de Cierre Mental
              </li>
            </ul>
          </div>

          <div className="mb-10" data-id="element-15">
            <p className="text-zinc-500 uppercase tracking-widest text-sm mb-2" data-id="element-16">
              Inversión Única
            </p>
            <div className="text-6xl font-serif text-zinc-100 flex items-start justify-center" data-id="element-17">
              <span className="text-3xl mt-2 mr-1 text-amber-500" data-id="element-18">$</span>
              6.39
              <span className="text-xl mt-auto mb-2 ml-2 text-zinc-500" data-id="element-19">
                USD
              </span>
            </div>
          </div>

          <a href="https://www.protocoloperdon.com/cart/44264875327581:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto px-12 py-5 bg-amber-600 hover:bg-amber-500 text-zinc-950 font-bold text-lg tracking-wide transition-all duration-300 shadow-[0_0_30px_rgba(217,119,6,0.2)] hover:shadow-[0_0_50px_rgba(217,119,6,0.4)] transform hover:-translate-y-1 text-center" data-id="element-20">
            RECLAMAR MI SOBERANÍA AHORA
          </a>

          <p className="mt-6 text-zinc-500 text-sm" data-id="element-21">
            Acceso seguro e inmediato. Tu paz no puede esperar.
          </p>
        </div>
      </div>
    </section>;
}